const STORAGE_KEY_PREFIX = "chatAgentPromptId";
const LEGACY_ASSISTANT_KEY_PREFIX = "crm-assistant-prompt-id";

export const getPromptStorageKey = (companyId) =>
  `${STORAGE_KEY_PREFIX}_${companyId}`;

const readStoredRaw = (companyId) => {
  if (!companyId) return null;

  const primary = localStorage.getItem(getPromptStorageKey(companyId));
  if (primary) return primary;

  const legacy = localStorage.getItem(`${LEGACY_ASSISTANT_KEY_PREFIX}-${companyId}`);
  if (legacy) {
    localStorage.setItem(getPromptStorageKey(companyId), legacy);
    localStorage.removeItem(`${LEGACY_ASSISTANT_KEY_PREFIX}-${companyId}`);
    return legacy;
  }

  return null;
};

export const loadSelectedPromptId = (companyId, prompts = []) => {
  const storedRaw = readStoredRaw(companyId);
  if (!storedRaw) return null;

  const storedId = Number(storedRaw);
  if (Number.isNaN(storedId)) return null;

  if (!prompts.length) return storedId;

  const allowedIds = prompts.map((prompt) => Number(prompt.id));
  return allowedIds.includes(storedId) ? storedId : null;
};

export const saveSelectedPromptId = (companyId, promptId) => {
  if (!companyId || !promptId) return;
  localStorage.setItem(getPromptStorageKey(companyId), String(promptId));
};

export const resolveSelectedPromptId = ({
  companyId,
  prompts = [],
  currentId = null,
}) => {
  const fromStorage = loadSelectedPromptId(companyId, prompts);
  if (fromStorage) return fromStorage;

  const allowedIds = prompts.map((prompt) => Number(prompt.id));
  const normalizedCurrent = currentId ? Number(currentId) : null;

  if (normalizedCurrent && allowedIds.includes(normalizedCurrent)) {
    saveSelectedPromptId(companyId, normalizedCurrent);
    return normalizedCurrent;
  }

  return null;
};
